module.exports = __webpack_public_path__ + "img/home-third.2da6e3cf.svg";